import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import isEmpty from 'lodash/isEmpty';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteSection
} from 'zoomforth_codesbane_editor/action_creators/sections.js';

import {
  getLongDisplayName
} from 'zoomforth_codesbane_viewer/lib/sections.js';

const mapStateToProps = (state, { section }) => {
  return {
    title: 'Really delete section?',
    body: `You are about to delete this ${getLongDisplayName(section)} Section. 
      This will delete all of the content in this section. This cannot be undone.`,
    confirmText: 'Delete Section',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { section, hasMenuItems }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(deleteSection(section));

      // if there are linked menu items for the section then we show a
      // confirmation modal to delete those items. Calling closeModal can cause
      // a timing issue where that next modal is closed before being able to
      // interact with it.
      if (isEmpty(hasMenuItems)) {
        dispatch(closeModal());
      }
    }
  }
);

const ConfirmDeleteSectionModal = connect(
  mapStateToProps,
  mapDispatchToProps

)(ConfirmDeleteModal);

ConfirmDeleteSectionModal.editorModalName = 'ConfirmDeleteSectionModal';

export default ConfirmDeleteSectionModal;
